import React from "react";
import InnerLayout from "./InnerLayout";

const leadershipVideos = [
  {
    title: "Principal's Message",
    embedUrl: "https://www.youtube.com/embed/5_osELJfgn4",
  },
  {
    title: "Dean Admin Message",
    embedUrl: "https://www.youtube.com/embed/5tFAQ849Ng0",
  },
  {
    title: "Dean Academics Message",
    embedUrl: "https://www.youtube.com/embed/axV2BmL749k",
  },
  {
    title: "Dean R & D Message",
    embedUrl: "https://www.youtube.com/embed/3_jNSKTPG2A",
  },
  {
    title: "IQAC Message",
    embedUrl: "https://www.youtube.com/embed/Z3489YHlnHk",
  },
  {
    title: "Registrar Message",
    embedUrl: "https://www.youtube.com/embed/kfNpBjZfdPM",
  },
];

const Leadership = () => (
  <InnerLayout
    title="Leadership"
    image="/Campus/hero.jpg"
    breadcrumbs={[
      { label: "About", to: "/about" },
      { label: "Leadership" },
    ]}
  >
    <div className="space-y-8">
      <div className="vdit-prose">
        <p>
          KLS VDIT is guided by committed leadership focused on academic
          excellence, institutional development, research, innovation, and
          student success.
        </p>
      </div>

      <section className="space-y-5">
        <div>
          <h2
            className="text-2xl md:text-3xl text-brand font-semibold"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Leadership Videos
          </h2>
        </div>

        <div className="grid gap-5">
          {leadershipVideos.map((video) => (
            <article
              key={video.title}
              className="bg-white border border-brand/15 overflow-hidden"
            >
              <div className="aspect-video bg-black">
                <iframe
                  className="w-full h-full"
                  src={video.embedUrl}
                  title={`${video.title} leadership video`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              </div>
              <div className="p-4">
                <h3 className="text-brand font-semibold">{video.title}</h3>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  </InnerLayout>
);

export default Leadership;